module.exports = __webpack_public_path__ + "static/media/300_5.c9e0d2ab.jpg";